export const PLUGIN_NAME: string = 'merge_tags';

export const COMMAND_NAME: string = 'pmAddMergeTag'; // pm - PushMetrics
